import React from 'react';
import { useContextSelector } from 'use-context-selector';
import { MarkdownOpenExternalLinkCtx } from '../ctx/OpenExternalLinkCtx';

const TagP = React.forwardRef<
  HTMLParagraphElement,
  React.DetailedHTMLProps<React.ParamHTMLAttributes<HTMLParagraphElement>, HTMLParagraphElement>
>(function (props, ref) {
  // TODO: 现在是在运行时解除一层引用关系，之后应该尝试放在解析器层进行接触一层引用关系。
  const hasBlockExternalComponent = useContextSelector(
    MarkdownOpenExternalLinkCtx,
    (data) => data.hasBlockExternalComponent,
  );
  if (React.isValidElement(props.children) && hasBlockExternalComponent?.(props.children.type)) {
    return <>{props.children}</>;
  }
  return <section {...props} ref={ref} />;
});

export { TagP };
